module.exports = __webpack_public_path__ + "9afb51aacc73f733e3d703e5cc582ea0.pdf";